import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  withStyles,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { FaTrash } from 'react-icons/fa';
import { MdPersonAddAlt1 } from 'react-icons/md';
import { useAsignatures } from '../asginatures/Asignatures';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#2490AF',
    color: theme.palette.common.white,
    fontSize: 17,
    fontFamily: 'Roboto',
  },
  body: {
    fontSize: 14,
    fontFamily: 'Roboto',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    cursor: 'pointer',
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  imagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
}));

export function useSeries() {
  const [series, setSeries] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/series')
      .then((response) => response.json())
      .then((data) => {
        setSeries(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { series, setSeries };
}

export default function CreateSerie() {
  const classes = useStyles();
  const { series, setSeries } = useSeries();
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const { asignatures } = useAsignatures();
  const [image, setImage] = React.useState('');
  const [asignature, setAsignature] = React.useState('');
  const [snackCreateSuccessOpen, setSnackCreateSuccessOpen] =
    React.useState(false);
  const [snackCreateInfoOpen, setSnackCreateInfoOpen] = React.useState(false);
  const [snackErrorOpen, setSnackErrorOpen] = React.useState(false);
  const [selectedSerie, setSelectedSerie] = React.useState(null);
  const filePickerRef = React.useRef(null);
  const imagePreviewRef = React.useRef(null);
  const handleSnackCreateSuccessClose = () => {
    setSnackCreateSuccessOpen(false);
  };

  const handleSnackErrorClose = () => {
    setSnackErrorOpen(false);
  };

  const handleSnackCreateInfoClose = () => {
    setSnackCreateInfoOpen(false);
  };
  const handleCreate = async () => {
    try {
      if (name && description && image) {
        let formData = new FormData();
        formData.append('name', name);
        formData.append('description', description);
        formData.append('asignature', asignature);
        formData.append('image', image);
        let response = await fetch(
          'https://api.edicionesmilenio.com/api/series',
          {
            method: 'POST',
            body: formData,
          }
        );
        let data = await response.json();
        if (data.success === true) {
          setSeries([...series, data?.data]);
          setSnackCreateSuccessOpen(true);
        } else {
          setSnackErrorOpen(true);
        }
        setName('');
        setDescription('');
        setAsignature('');
        setImage('');
      } else {
        setSnackCreateInfoOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleUpdate = async () => {
    try {
      let formData = new FormData();
      formData.append('name', name);
      formData.append('description', description);
      formData.append('asignature', asignature);
      formData.append('image', image);
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/series/${selectedSerie?._id}`,
        {
          method: 'PUT',
          body: formData,
        }
      );

      let data = await response.json();
      if (data.success) {
        let index = series.findIndex((g) => g._id === selectedSerie?._id);
        series.splice(index, 1, data?.data);
        setSeries(series);
        setSelectedSerie(data?.data);
        setSnackCreateSuccessOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  const handleDelete = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/series/${selectedSerie?._id}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      let data = await response.json();
      if (data.success) {
        let seriesDeleted = series.filter((g) => g?._id !== selectedSerie?._id);
        setSeries(seriesDeleted);
        setSnackCreateSuccessOpen(true);

        setName('');
        setDescription('');
        setAsignature('');
        setImage('');
      }
    } catch (error) {
      console.error(error);
      setSnackErrorOpen(true);
    }
  };

  useEffect(() => {
    if (selectedSerie) {
      setName(selectedSerie?.name);
      setDescription(selectedSerie?.description);
      setImage(selectedSerie?.image);
    }
  }, [selectedSerie]);
  return (
    <div className={classes.container} style={{ width: '100%' }}>
      <TableContainer className={classes.TableContainer} component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nombre</StyledTableCell>
              <StyledTableCell>Asignatura</StyledTableCell>
              <StyledTableCell>Fecha De Creación</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {series.map((row) => (
              <StyledTableRow
                onClick={() => setSelectedSerie(row)}
                key={row?._id}
              >
                <StyledTableCell>{row?.name}</StyledTableCell>
                <StyledTableCell>{row?.asignature?.name}</StyledTableCell>
                <StyledTableCell>{row?.createdAt}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, mediante este formulario usted podrá crear,
          actualizar o eliminar las series de la plataforma.
        </p>
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Nombre la serie"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          className={classes.input}
          id="outlined-basic"
          label="Descripción"
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel id="demo-simple-select-outlined-label">
            Asignatura de la serie
          </InputLabel>

          <Select
            onChange={(e) => setAsignature(e.target.value)}
            value={asignature}
            id="select-asignature"
          >
            <MenuItem value="" disabled>
              <em>Seleccione una asignatura</em>
            </MenuItem>
            {asignatures.map((asignature) => (
              <MenuItem value={asignature._id}>{asignature.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div
          onClick={() => {
            setImage(null);
            filePickerRef.current.click();
          }}
          className={classes.imagePicker}
        >
          {image && (
            <img
              style={{ width: '50px', height: '50px', marginRight: '20px' }}
              ref={imagePreviewRef}
              src={
                typeof image === 'string'
                  ? 'https://api.edicionesmilenio.com/' + image
                  : URL.createObjectURL(image)
              }
              alt="preview"
            />
          )}
          <input
            ref={filePickerRef}
            style={{ display: 'none' }}
            type="file"
            name="image"
            onChange={(e) => {
              setImage(e.target.files[0]);
              const reader = new FileReader();
              reader.onload = (e) => {
                imagePreviewRef.current.src = e.target.result;
              };
              reader.readAsDataURL(e.target.files[0]);
            }}
            accept="image/*"
          />
          {image && <p>{image?.name}</p>}
          {!image && (
            <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
              Seleccione una imagen para la serie
            </p>
          )}
        </div>
        <Button
          onClick={() => {
            setSelectedSerie(null);
            setName('');
            setDescription('');
            setImage('');
            setAsignature('');
          }}
        >
          Limpiar
        </Button>
        <div className={classes.formButtonsContainer}>
          <Button variant="contained" color="secondary" onClick={handleDelete}>
            <FaTrash size={15} />
            Eliminar
          </Button>
          <Button variant="contained" onClick={handleUpdate}>
            <AiFillEdit size={15} />
            Actualizar
          </Button>
          <Button onClick={handleCreate} variant="contained" color="primary">
            <MdPersonAddAlt1 size={15} />
            Crear
          </Button>
        </div>
      </form>
      <Snackbar
        open={snackCreateSuccessOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateSuccessClose}
      >
        <Alert onClose={handleSnackCreateSuccessClose} severity="success">
          Se ha creado la serie exitosamente
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackCreateInfoOpen}
        autoHideDuration={6000}
        onClose={handleSnackCreateInfoClose}
      >
        <Alert onClose={handleSnackCreateInfoClose} severity="warning">
          Estimado administrador para crear una serie, por favor llene los
          campos requeridos
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackErrorOpen}
        autoHideDuration={6000}
        onClose={handleSnackErrorClose}
      >
        <Alert onClose={handleSnackErrorClose} severity="error">
          Hubo un error al intentar realizar la operación, por favor intente
          nuevamente
        </Alert>
      </Snackbar>
    </div>
  );
}
